<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '5月告白季狂送好礼，快来领取>>',
                desc: '最高70天会员免费领、求职技能包限量送，进入会场领取甜蜜好礼',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20220511/1652255266041.png'
            });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>